export default __webpack_public_path__ + "static/media/wn_7_2.00d09964.webp";